// frontend/src/components/cashier/ConfigModal.js
import { api } from '../../services/api.js';
import { Notification } from '../Notification.js';
import { cashierContext } from '../../context/CashierContext.js';
import { authService } from '../../services/authService.js';
//import { checkAndHandleSessionExpiry } from '../../utils/authHelpers.js';
export const openConfigModal = async () => {
    let modal = document.getElementById('config-modal');
    
    // Si no existe, lo creamos en el body
    if (!modal) {
        modal = document.createElement('div');
        modal.id = 'config-modal';
        modal.className = 'config-popup-overlay';
        
        // HTML EXACTO de tu código original
        modal.innerHTML = `
            <div class="config-popup-content">
                <button class="config-popup-close-btn">&times;</button>
                <h2>Configuraciones de Taquilla</h2>

                <div class="config-section">
                    <h3>Número de Teléfono Asociado</h3>
                    <p>Este número es gestionado por el administrador y se usa para enviar tokens de validación.</p>
                    <div class="flex-grow w-full">
                        <label for="config-phone-number">Número de Teléfono Registrado:</label>
                        <input type="tel" id="config-phone-number" readonly class="bg-gray-800 cursor-not-allowed">
                    </div>
                </div>

                <div class="config-section">
                    <h3>Políticas de Acceso por Usuario</h3>
                    <p>Define límites para la operación antes de requerir una re-validación.</p>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label for="venta-ticket-max">Máx. Tickets Vendidos antes de Bloqueo:</label>
                            <input type="number" id="venta-ticket-max" min="0">
                        </div>
                        <div>
                            <label for="pago-premio-max">Máx. Monto Pagado ($) antes de Bloquea:</label>
                            <input type="number" id="pago-premio-max" min="0" step="0.01">
                        </div>
                    </div>
                    <button id="save-access-policy-btn" class="config-button primary mt-4">Guardar Políticas</button>
                </div>

                <div class="config-section">
                    <h3>Límites de Apuestas por Ticket</h3>
                    <p>Establece los montos mínimo y máximo permitidos por boleto.</p>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label for="monto-minimo-ticket">Monto Mínimo por Ticket ($):</label>
                            <input type="number" id="monto-minimo-ticket" min="0.01" step="0.01">
                        </div>
                        <div>
                            <label for="monto-maximo-ticket">Monto Máximo por Ticket ($):</label>
                            <input type="number" id="monto-maximo-ticket" min="0.01" step="0.01">
                        </div>
                    </div>
                    <button id="save-bet-limits-btn" class="config-button primary mt-4">Guardar Límites</button>
                </div>

                <div class="config-section">
                    <h3>Pago al Taquillero</h3>
                    <p>Configura el pago diario y visualiza el monto adeudado.</p>
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label for="hourly-pay">Pago Diario ($):</label>
                            <input type="number" id="hourly-pay" min="0" step="0.01">
                        </div>
                        <div>
                            <label>Pago Semanal (Calculado):</label>
                            <p id="weekly-pay-display" class="bg-gray-700 p-2 rounded-md font-semibold text-white">0.00</p>
                        </div>
                    </div>
                    <div class="mt-4">
                        <label>Monto Adeudado (acumulado):</label>
                        <p id="amount-owed-display" class="bg-gray-700 p-2 rounded-md font-semibold text-white">0.00</p>
                        <p class="text-sm text-gray-400 mt-1">Este monto se reinicia al realizar el cuadre de caja.</p>
                    </div>
                    <button id="save-teller-pay-btn" class="config-button primary mt-4">Guardar Configuración de Pago</button>
                </div>
                <div class="config-section" id="token-validation-area">
                     <h3>Validación para Guardar Cambios</h3>
                     <p>Para guardar cambios en las políticas o límites, solicita un token a tu número de teléfono y luego ingrésalo aquí.</p>
                     <div class="flex flex-col sm:flex-row items-end gap-3">
                        <div class="flex-grow w-full">
                            <label for="validation-token" class="text-blue-300">Token de 4 dígitos:</label>
                            <input type="text" id="validation-token" maxlength="4" class="text-center text-lg font-bold" placeholder="_ _ _ _">
                        </div>
                        <button id="send-token-btn" class="config-button secondary w-full sm:w-auto">Enviar Token</button>
                    </div>
                </div>

                <div class="config-popup-footer">
                    <button id="close-config-modal-btn" class="config-button cancel">Cerrar</button>
                </div>
            </div>
        `;
        document.body.appendChild(modal);

        // Lógicas de cerrado
        const closePopup = () => modal.classList.remove('visible');
        modal.querySelector('.config-popup-close-btn').addEventListener('click', closePopup);
        modal.querySelector('#close-config-modal-btn').addEventListener('click', closePopup);
        modal.addEventListener('click', (e) => { if (e.target === modal) closePopup(); });

        // --- Funciones de Guardado ---
        const saveConfigToBackend = async (updates, requiresToken = false) => {
            try {
                const payload = { ...updates };
                if (requiresToken) {
                    const enteredToken = modal.querySelector('#validation-token').value.trim();
                    if (!enteredToken) return Notification(document.body, 'Ingrese el token de validación para guardar.', 'error');
                    payload.validation_token = enteredToken;
                }

                const response = await api.put('/configs/cashier', payload);
                // Actualizamos el contexto global
                cashierContext.update({ config: { ...cashierContext.state.config, ...response.config } });
                Notification(document.body, response.message || 'Configuración guardada.', 'success');
                modal.querySelector('#validation-token').value = '';
                
                // Recargamos visualmente los datos
                await loadAndPopulateData();
                return true;
            } catch (error) {
                if (checkAndHandleSessionExpiry(error, document.body)) return false;
                Notification(document.body, error.response?.data?.error || error.message || 'Error al guardar configuración.', 'error');
                return false;
            }
        };

        // Eventos de botones
        modal.querySelector('#send-token-btn').addEventListener('click', async (e) => {
            const phoneNumber = cashierContext.state.config.phone_number;
            if (!phoneNumber) return Notification(document.body, 'No hay un número configurado.', 'error');
            try {
                Notification(document.body, `Enviando token a ${phoneNumber}...`, 'info');
                await api.post('/configs/request-token', { phoneNumber: phoneNumber });
                e.target.disabled = true;
                setTimeout(() => { e.target.disabled = false; }, 60000);
                Notification(document.body, 'Token enviado. Revísalo en WhatsApp/Telegram.', 'success');
            } catch (error) {
                Notification(document.body, `Error al enviar token: ${error.message}`, 'error');
            }
        });

        modal.querySelector('#save-access-policy-btn').addEventListener('click', async () => {
            await saveConfigToBackend({
                venta_ticket_max: parseInt(modal.querySelector('#venta-ticket-max').value) || 0,
                pago_premio_max: parseFloat(modal.querySelector('#pago-premio-max').value) || 0.00,
            }, true);
        });

        modal.querySelector('#save-bet-limits-btn').addEventListener('click', async () => {
            const minAmount = parseFloat(modal.querySelector('#monto-minimo-ticket').value) || 1.00;
            const maxAmount = parseFloat(modal.querySelector('#monto-maximo-ticket').value) || 500.00;
            if (minAmount > maxAmount) return Notification(document.body, 'El monto mínimo no puede ser mayor que el máximo.', 'error');
            await saveConfigToBackend({ monto_minimo_ticket: minAmount, monto_maximo_ticket: maxAmount }, true);
        });

        modal.querySelector('#hourly-pay').addEventListener('input', (e) => {
            const hourlyPay = parseFloat(e.target.value) || 0;
            modal.querySelector('#weekly-pay-display').textContent = (hourlyPay * 8 * 7).toFixed(2);
        });

        modal.querySelector('#save-teller-pay-btn').addEventListener('click', async () => {
            await saveConfigToBackend({ hourly_pay: parseFloat(modal.querySelector('#hourly-pay').value) || 0 }, true);
        });
    }

    // Función para leer de la API y llenar los inputs
    const loadAndPopulateData = async () => {
        try {
            const config = await api.get('/configs/cashier');
            cashierContext.update({ config: config, exchangeRate: parseFloat(config.exchange_rate) || 0 });
            
            modal.querySelector('#config-phone-number').value = config.phone_number || '';
            modal.querySelector('#venta-ticket-max').value = config.venta_ticket_max || 0;
            modal.querySelector('#pago-premio-max').value = parseFloat(config.pago_premio_max || 0).toFixed(2);
            modal.querySelector('#monto-minimo-ticket').value = parseFloat(config.monto_minimo_ticket || 1).toFixed(2);
            modal.querySelector('#monto-maximo-ticket').value = parseFloat(config.monto_maximo_ticket || 500).toFixed(2);
            
            const hourlyPay = parseFloat(config.hourly_pay || 0);
            modal.querySelector('#hourly-pay').value = hourlyPay.toFixed(2);
            modal.querySelector('#weekly-pay-display').textContent = (hourlyPay * 8 * 7).toFixed(2);
            modal.querySelector('#amount-owed-display').textContent = parseFloat(config.amount_owed || 0).toFixed(2);
        } catch (error) {
            Notification(document.body, 'Error al cargar la configuración.', 'error');
        }
    };

    await loadAndPopulateData();
    modal.classList.add('visible');
};